<template>
  <div class="a-no-image">
    <span>No image</span>
  </div>
</template>
